module.exports = __webpack_public_path__ + "img/DeskStationaryA01.c77ec543.png";